//
// Module for Add of a Benefit Formula Table
//
rs.module("content/system_/configuration/benefitformulatables/add",

    ["common/visibility"],

    function (visibility) {

        // Initialize the module
        function initialize(jsSelectors, codeValues) {
            var mainTableGroup = $.js(jsSelectors.mainTableGroup);

            var tableTypeSelect = mainTableGroup.js(jsSelectors.tableTypeSelect);

            var ageBasedMultiplier = mainTableGroup.js(jsSelectors.ageBasedMultiplier);
            var graduatedReductionFactor = mainTableGroup.js(jsSelectors.graduatedReductionFactor);
            var tieredAgeAdjustment = mainTableGroup.js(jsSelectors.tieredAgeAdjustment);

            // display appropriate fields based on type selection
            tableTypeSelect.change(function () {

                if (tableTypeSelect.val() == codeValues.ageBasedMultiplier) {
                    visibility.show(ageBasedMultiplier);
                } else {
                    visibility.hide(ageBasedMultiplier);
                }

                if (tableTypeSelect.val() == codeValues.graduatedReductionFactor) {
                    visibility.show(graduatedReductionFactor);
                } else {
                    visibility.hide(graduatedReductionFactor);
                }

                if (tableTypeSelect.val() == codeValues.tieredAgeAdjustment) {
                    visibility.show(tieredAgeAdjustment);
                } else {
                    visibility.hide(tieredAgeAdjustment);
                }

            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);